import { ref, computed } from "vue";
import { showToast, exceptionRequestMsg } from "@/assets/js/util";
import appApi from "@/services/api";
const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");

const useUsuario = () => {
  const usuarios = ref({});
  const loadingPage = ref(true);
  const value = ref("");
  const options = ref([]);
  const roles = ref([]);
  const passwordType = ref("password");
  const modalTitle = ref(null);
  const loadingBtn = ref(false);
  const showSectionPassword = ref(true);
  const formAction = ref("");
  const listaUsuarios = ref([]);
  const lider_id = ref(null);

  const usuario_id = ref(null);
  const nombre = ref("");
  const paterno = ref("");
  const materno = ref("");
  const correo = ref(null);
  const contrasena = ref(null);
  const rol = ref(null);
  const Close = ref(null);
  const arrendamientosByUser = ref({});
  const loadingBtnEdit = ref(false);

  const password = ref(null);
  const confirm_password = ref(null);

  const submitForm = async () => {
    const form = document.getElementById("formUsuario");
    const formData = new FormData(form);

    if (value.value.length == 0) {
      showToast("Seleccione al menos un arrendamiento", "warning");
      return;
    }

    const arrendamientos = value.value.map(
      (arrendamientos) => arrendamientos.id
    );

    formData.append("arrendamientos", arrendamientos);
    formData.append("lider_id", lider_id?.value?.id ?? "");
    loadingBtn.value = true;

    if (formAction.value == "crear") {
      await createUser(formData);
    } else if (formAction.value == "modificar") {
      await updateUser(formData);
    } else {
      showToast("Error", "error");
    }
  };

  const updateEstatus = async (activo, usuario) => {
    loadingPage.value = true;
    const nuevoEstatus = activo ? 0 : 1;
    const formData = new FormData();
    formData.append("estatus", nuevoEstatus);
    formData.append("_method", "PUT");
    try {
      const response = await appApi().post(
        `usuarios/update/estatus/${usuario}`,
        formData
      );

      const { status, message } = response.data;

      if (!status) {
        showToast(message, "error");
        loadingPage.value = false;
        return;
      }

      await fetchUsuarios();
      loadingPage.value = false;
      showToast(message, "success");
    } catch (e) {
      loadingPage.value = false;
      exceptionRequestMsg(e);
    }
  };

  const fetchUsuarios = async (page = 1) => {
    loadingPage.value = true;
    const response = await appApi().get(`usuarios?page=${page}`);
    await fetchAllUsers();
    console.log(listaUsuarios.value);
    usuarios.value = response.data;
    loadingPage.value = false;
  };

  const fetchAllUsers = async () => {
    const response = await appApi().get(`usuarios?all=true`);
    listaUsuarios.value = response.data;
  };

  const createUser = async (formData) => {
    formData.append("_method", "POST");
    try {
      const response = await appApi().post("usuarios/store", formData);
      const { status, message } = response.data;

      loadingBtn.value = false;

      if (!status) {
        showToast(message, "error");
        return;
      }

      Close.value.click();

      await fetchUsuarios();
      showToast(message, "success");
    } catch (e) {
      loadingBtn.value = false;
      exceptionRequestMsg(e);
    }
  };

  const showModal = (modalId) => {
    const myModal = new bootstrap.Modal(document.getElementById(modalId));

    myModal.show();
  };

  const openModal = () => {
    nombre.value = "";
    paterno.value = "";
    materno.value = "";
    correo.value = null;
    rol.value = null;
    showSectionPassword.value = false;
    usuario_id.value = null;
    showSectionPassword.value = true;
    modalTitle.value = "Nuevo usuario";
    arrendamientosByUser.value = {};
    lider_id.value = null;
    value.value = [];
    formAction.value = "crear";

    showModal("staticBackdrop");
  };

  const showModalUsuario = async (usuario) => {
    loadingPage.value = true;
    loadingBtnEdit.value = true;
    nombre.value = usuario.nombre;
    paterno.value = usuario.paterno;
    materno.value = usuario.materno;
    correo.value = usuario.email;
    rol.value = usuario.grupo_id;
    usuario_id.value = usuario.id;
    showSectionPassword.value = false;
    const nombreCompleto = `${usuario.nombre} ${usuario.paterno}`.trim();
    modalTitle.value = nombreCompleto;
    formAction.value = "modificar";

    if (usuario.lider_id) {
      lider_id.value = listaUsuarios.value.filter(
        (user) => user.id == usuario.lider_id
      )[0];
    }

    await fetchArrendamientosByUser(usuario.id);

    loadingBtnEdit.value = false;
    loadingPage.value = false;
    showModal("staticBackdrop");
  };

  const closeModal = () => {
    console.log("cerrando modal");
    Close.value.click();
  };

  const fetchArrendamientosByUser = async (user_id) => {
    try {
      const response = await appApi().get(`usuarios/arrendamientos/${user_id}`);
      arrendamientosByUser.value = response.data;
      value.value = response.data;
      const valoresCoincidentes = Object.values(options.value).filter(
        (objeto) => {
          return Object.values(value.value).some(
            (valor) => valor.arrendamiento_tipo_id === objeto.id
          );
        }
      );
      value.value = valoresCoincidentes;
      //console.log(options.value.find(option => option.id === 1));
      //value.value = options.value.find(option => option.id === 1);
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    }
  };

  const iconPassword = computed(() => {
    return passwordType.value == "password" ? "ri-eye-line" : "ri-eye-off-line";
  });

  const updateUser = async (formData) => {
    formData.append("_method", "PUT");
    try {
      const response = await appApi().post(
        `usuarios/update/${usuario_id.value}`,
        formData
      );

      console.log(response);

      const { status, message } = response.data;
      loadingBtn.value = false;

      if (!status) {
        showToast(message, "error");
        return;
      }

      Close.value.click();

      await fetchUsuarios();
      showToast(message, "success");
    } catch (e) {
      console.log(e);
      loadingBtn.value = false;
      exceptionRequestMsg(e);
    }
  };

  const openModalPassword = (usuario) => {
    usuario_id.value = usuario.id;
    showModal("modalPassword");
  };

  const updateUserPassword = async () => {
    if (password.value != confirm_password.value) {
      showToast("Las contraseñas ingresadas no coinciden", "warning");
      return;
    }

    loadingBtn.value = true;
    const form = document.getElementById("formPassword");
    const formData = new FormData(form);
    formData.append("_method", "PUT");

    try {
      const response = await appApi().post(
        `usuarios/password/update/${usuario_id.value}`,
        formData
      );

      const { status, message } = response.data;
      loadingBtn.value = false;

      if (!status) {
        showToast(message, "error");
        return;
      }

      Close.value.click();

      password.value = "";
      confirm_password.value = "";

      await fetchUsuarios();
      showToast(message, "success");
    } catch (e) {
      loadingBtn.value = false;
      exceptionRequestMsg(e);
    }
  };

  const getUsuarioLoggeado = async () => {
    try {
      const response = await appApi().get(`usuarios/show`);

      return response.data;
    } catch (error) {
      console.log(error);
      exceptionRequestMsg(error);
    }
  };

  return {
    usuarios,
    loadingPage,
    value,
    options,
    roles,
    passwordType,
    modalTitle,
    loadingBtn,
    updateEstatus,
    fetchUsuarios,
    createUser,
    iconPassword,
    showModalUsuario,
    nombre,
    paterno,
    materno,
    correo,
    contrasena,
    rol,
    showSectionPassword,
    closeModal,
    Close,
    usuario_id,
    openModal,
    arrendamientosByUser,
    submitForm,
    openModalPassword,
    password,
    confirm_password,
    updateUserPassword,
    loadingBtnEdit,
    getUsuarioLoggeado,
    listaUsuarios,
    lider_id,

    textoActivacion: (activo) => {
      return activo ? "Desactivar" : "Activar";
    },

    fetchRolesUsuario: async () => {
      try {
        const response = await appApi().get("usuarios/roles");
        roles.value = response.data;
      } catch (e) {
        exceptionRequestMsg(e);
      }
    },

    togglePassword: () => {
      passwordType.value == "password"
        ? (passwordType.value = "text")
        : (passwordType.value = "password");
    },

    fetchArrendamientoTipos: async () => {
      try {
        const response = await appApi().get("arrendamientos");
        options.value = response.data;
      } catch (e) {
        exceptionRequestMsg(e);
      }
    },
  };
};

export default useUsuario;
